import { render, staticRenderFns } from "./doctorDetail.vue?vue&type=template&id=eb20b148&scoped=true&"
import script from "./doctorDetail.vue?vue&type=script&lang=js&"
export * from "./doctorDetail.vue?vue&type=script&lang=js&"
import style0 from "./doctorDetail.vue?vue&type=style&index=0&id=eb20b148&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb20b148",
  null
  
)

export default component.exports